<script>
import { defineComponent, inject } from 'vue'
import { getGlobalFeatures, useI18nInjection, getTranslationsInjection } from '../index'

export default defineComponent({
  name: 'LanguageSwitcher',

  setup () {
    const { USE_I18N } = getGlobalFeatures()

    let i18n
    let locales

    if (USE_I18N) {
      i18n = inject(useI18nInjection)()
      locales = inject(getTranslationsInjection)()
    }

    return {
      i18n,
      locales
    }
  }
})
</script>

<template>
  <nav v-if="locales" class="language-switcher">
    <template v-for="(value, key) of locales">
      <slot :isCurrent="i18n.locale.value === key" :localeCode="key" :localeLabel="value.name">
        <router-link :key="key" :to="{ params: { locale: key } }">{{ value.name }}</router-link>
      </slot>
    </template>
  </nav>
</template>
